import React, { memo } from "react";
import SectionRu from "../Sections/SectionRu";
import SectionEn from "../Sections/SectionEn";
import SectionEs from "../Sections/SectionEs";
import SectionAr from "../Sections/SectionAr";
import SectionTr from "../Sections/SectionTr";
import SectionVi from "../Sections/SectionVi";
import "./Main.css";

const SECTIONS = {
  en: SectionEn,
  ru: SectionRu,
  es: SectionEs,
  ar: SectionAr,
  tr: SectionTr,
  vi: SectionVi,
};

const Main = ({ language }) => {
  const Component = SECTIONS[language];

  return (
    <main className="app-main">
      <div className="app-main-content">
        <Component />
      </div>
    </main>
  );
};

export default memo(Main);
